import styled from 'styled-components';
import { Flex } from '@radix-ui/themes';

import TabNavigation from '../../../../shared/TabNavigation';
import LoadingComponent from '../../../../shared/LoadingComponent';
import { usePlans } from '../../../../lib/hooks/usePlans';
import { UpgradeBanner } from '../../../../shared/UpgradeBanner/index.jsx';

export const TopBar = ({ children }) => {
  const { plans, isFetching } = usePlans();
  const tabs = [
    { name: 'Manage Users', to: '/', exact: true },
    { name: 'All Users', to: 'all-users' },
    { name: 'Population Segments', to: 'population-segments' },
    { name: 'Audiences', to: 'audiences' },
  ];

  if (isFetching) return <LoadingComponent />;

  return (
    <>
      {!plans?.users && (
        <Flex justify="center" p="24px 24px 0">
          <UpgradeBanner
            icon="fa-regular fa-users"
            titleKey="users.title"
            countValue={plans?.audienceInfo.remainingAudienceCount}
            countLimit={plans?.audienceInfo.audienceLimit}
            textContent={(t, Trans) => (
              <>
                <Trans
                  i18nKey="users.text1"
                  count={plans?.audienceInfo.audienceLimit}
                  components={{ strong: <strong /> }}
                  values={{
                    limit: plans?.audienceInfo.audienceLimit,
                    pluralS: plans?.audienceInfo.audienceLimit === 1 ? '' : 's',
                  }}
                  ns="upgradeBanners"
                />
              </>
            )}
          />
        </Flex>
      )}
      <Wrapper>
        <TabNavigation tabs={tabs} />
        {children}
      </Wrapper>
    </>
  );
};

const Wrapper = styled.div`
  display: flex;
  margin: 24px;
`;
